import React from "react";
import { CheckCircle2, Circle, Loader2 } from "lucide-react";

/**
 * Contribution journey stepper: Received -> Allocated -> Utilized -> Beneficiary -> Impact
 * Each step gets state: done | active | pending, based on data.
 */
export default function JourneyStepper({ steps }) {
  return (
    <div className="w-full">
      <ol className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {steps.map((s, i) => {
          const done = s.state === "done";
          const active = s.state === "active";
          return (
            <li key={s.id} data-testid={`journey-step-${s.id}`}
                className={`rounded-xl border p-4 transition-colors ${
                  done ? "bg-emerald-50 border-emerald-700/20"
                  : active ? "bg-orange-50 border-orange-700/30"
                  : "bg-white border-slate-200"
                }`}>
              <div className="flex items-center gap-2">
                {done ? <CheckCircle2 className="w-4 h-4 text-emerald-700" />
                  : active ? <Loader2 className="w-4 h-4 text-orange-600 animate-spin" />
                  : <Circle className="w-4 h-4 text-slate-400" />}
                <span className={`overline ${done ? "!text-emerald-800" : active ? "!text-orange-700" : "!text-slate-500"}`}>Step {i+1}</span>
              </div>
              <div className={`mt-2 font-display font-semibold ${done || active ? "text-emerald-950" : "text-slate-500"}`}>
                {s.label}
              </div>
              {s.detail && (
                <div className="mt-1 text-xs text-muted-foreground line-clamp-2">{s.detail}</div>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
